export default "__VITE_ASSET__BCz7PROa__"